import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { getVehiclesCount } from '../VehicleList.helpers';

import * as styles from './Actions.module.scss';

T.setTexts(require('../../texts.json'));

const Actions = ({ clearFilters, isLoading = false, onShowSelectedVehiclesClick, vehiclesCount = null }) => (
	<div className={styles.container}>
		<div className={styles.buttonContainer}>
			<Button
				fullWidth
				className="mw-button"
				label={getVehiclesCount('vehicleList.filters.showVehicle', vehiclesCount)}
				loading={isLoading}
				onClick={onShowSelectedVehiclesClick}
			/>
		</div>
		<Button
			fullWidth
			label={T.translate('vehicleList.filters.clearFilters')}
			onClick={clearFilters}
			variant="secondary"
		/>
	</div>
);

Actions.propTypes = {
	clearFilters: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
	onShowSelectedVehiclesClick: PropTypes.func.isRequired,
	vehiclesCount: PropTypes.number,
};

export default Actions;
